<script>
import Form, { formCreate } from '../../../../../components/form';
import request from '../../../../../utils/request';

import customerSaleArea from '../components/sale_area/sale_area.vue';
import contactInfo from '../components/contact_info/contact_info.vue';
import ExtendedInfo from '../components/extended_info/extend_info.vue';
import invoiceInfo from '../components/invoice_info/invoice_info.vue';
import customerUser from '../components/customer_user/customer_user.vue';
import terminalAdrInput from '../components/adr_input.vue';

formCreate.component('customerSaleArea', customerSaleArea);
formCreate.component('contactInfo', contactInfo);
formCreate.component('ExtendedInfo', ExtendedInfo);
formCreate.component('invoiceInfo', invoiceInfo);
formCreate.component('customerUser', customerUser);
formCreate.component('terminalAdrInput', terminalAdrInput);

export default {
  extends: Form,
  props: {
    id: String,
    noButton: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      provinceList: [],
      areaList: [],
      cityList: [],
      rule: [],
      mdmCustomerSaleAreaVos: [
        {
          areaOne: '',
          areaTwo: '',
          areaThree: '',
          id: new Date().getTime(),
        },
      ],

      mdmCustomerContactVos: [
        {
          contactMain: '1',
          contactName: '',
          contactPhone: '',
          ext1: '',
          id: new Date().getTime(),
        },
      ],
      mdmCustomerDockingVos: [
        {
          orgCode: '',
          positionCode: '',
          // channel: '',
          ext1: '', // 公司名称
          ext2: '', // 公司编码
          contactPhone: '',
          fullName: '',
          id: new Date().getTime(),
        },
      ], // 扩展信息
      // mdmCustomerBillVos: [
      //   {
      //     billCompany: '', // 开票单位
      //     taxNumber: '', // 税号
      //     legal: '', // 法人
      //     depositBank: '', // 开户银行
      //     bankAccount: '', // 银行账号
      //     billMain: '', // 是否是默认开票信息，1是0否
      //     id: new Date().getTime(),
      //   },
      // ],
      // 开票信息
      // mdmCustomerSaleAreaVosItem: {
      //   areaOne: '',
      //   areaTwo: '',
      //   areaThree: '',
      // },
      // mdmCustomerContactVosItem: {
      //   contactMain: '',
      //   contactName: '',
      //   contactPhone: '',
      // },
      mdmCustomerDockingVosItem: {
        orgCode: '',
        positionCode: '',
        // channel: '',
        ext1: '', // 公司编码
        ext2: '', // 公司名称
        contactPhone: '',
        fullName: '',
      },
      // mdmCustomerBillVosItem: {
      //   billCompany: '', // 开票单位
      //   taxNumber: '', // 税号
      //   legal: '', // 法人
      //   depositBank: '', // 开户银行
      //   bankAccount: '', // 银行账号
      //   billMain: '', // 是否是默认开票信息，1是0否
      // },
      showData: null,

    };
  },
  async created() {
    if (this.noButton) {
      this.buttons = {
        submit: false,
        close: false,
        loading: false,
        submitAudit: false,
      };
    }
    // 获取规则
    await this.getFormRule('customer_information_add', 'CRM20201127000000116');

    // 省、市、区
    const provinceName = this.getRule('provinceCode');
    const cityName = this.getRule('cityCode');
    const districtName = this.getRule('districtCode');
    provinceName.restful = '/mdm/mdmRegionController/selectStartWithProvince';
    provinceName.optionsKey = { label: 'regionName', value: 'regionCode' };
    provinceName.props = {
      ...provinceName.props,
      // filterable: true,
      // remote: true,
      remoteParams: 'regionName',
    };

    cityName.optionsKey = { label: 'regionName', value: 'regionCode' };
    districtName.optionsKey = { label: 'regionName', value: 'regionCode' };

    provinceName.restfulParams = {
      regionLevel: '1',
    };
    provinceName.on = {
      change: (val) => {
        console.log(val);
        if (val) {
          this.disabled(false, ['cityCode']);
        } else {
          this.disabled(true, ['cityCode', 'districtCode']);
        }
        cityName.value = '';
        districtName.value = '';
        if (!val) {
          cityName.restful = '';
          districtName.restful = '';
          return;
        }
        cityName.restfulParams = {
          parentCode: val,
        };
        cityName.restful = '/mdm/mdmRegionController/selectStartWithProvince';
        cityName.props = {
          ...cityName.props,
          filterable: true,
          remote: true,
          remoteParams: 'regionName',
        };
        cityName.refresh = true;
      },
    };
    cityName.on = {
      change: (val) => {
        if (val) {
          this.disabled(false, ['districtCode']);
        } else {
          this.disabled(true, ['districtCode']);
        }
        districtName.value = '';
        if (!val) {
          districtName.restful = '';
          return;
        }
        districtName.restfulParams = {
          parentCode: val,
        };
        districtName.restful = '/mdm/mdmRegionController/selectStartWithProvince';
        districtName.props = {
          ...districtName.props,
          filterable: true,
          remote: true,
          remoteParams: 'regionName',
        };
        districtName.refresh = true;
      },
    };

    // if (this.formConfig.code === 'add') {
    //   this.hiddenFields(true, ['title7', 'customerUserList']);
    // }

    // this.showData = await this.getDic();
    // this.showData.forEach((item) => {
    //   if (item.dictCode === 'sales_area') {
    //     if (item.dictValue === 'N') {
    //       this.hiddenFields(true, ['title2', 'mdmCustomerSaleAreaVos']);
    //     }
    //   }
    //   if (item.dictCode === 'contact_information') {
    //     if (item.dictValue === 'N') {
    //       this.hiddenFields(true, ['title3', 'mdmCustomerContactVos']);
    //     }
    //   }
    //   if (item.dictCode === 'extended_information') {
    //     if (item.dictValue === 'N') {
    //       this.hiddenFields(true, ['title4', 'mdmCustomerDockingVos']);
    //     }
    //   }
    //   if (item.dictCode === 'customer_bill') {
    //     if (item.dictValue === 'N') {
    //       this.hiddenFields(true, ['title5', 'mdmCustomerBillVos']);
    //     }
    //   }
    //   if (item.dictCode === 'extended_information_product') {
    //     if (item.dictValue === 'N') {
    //       const mdmCustomerDockingVos = this.getRule('mdmCustomerDockingVos');
    //       mdmCustomerDockingVos.props.showProduct = false;
    //     }
    //   }
    // });
    // if (this.formConfig.buttonCode === 'edit') {
    //   this.disabled(true, ['customerCode']);
    // }
    // const registeredAddress = this.getRule('registeredAddress');
    // registeredAddress.on = {
    //   ...registeredAddress.on,
    //   change: (e) => {
    //     registeredAddress.props = {
    //       ...registeredAddress.props,
    //       lng: (e.lng).toString(),
    //       lat: (e.lat).toString(),
    //     };
    //     this.setValue({
    //       longitude: e.lng,
    //       latitude: e.lat,
    //     });
    //   },
    // };

    // 销售区域
    // const mdmCustomerSaleAreaVos = this.getRule('mdmCustomerSaleAreaVos');
    // mdmCustomerSaleAreaVos.on = {
    //   del: (index) => {
    //     this.mdmCustomerSaleAreaVos.splice(index, 1);
    //   },
    // };
    // 销售区域显示添加按钮
    // const title2 = this.getRule('title2');
    // if (this.formConfig.code !== 'view') {
    //   title2.props.showAdd = true;
    // }
    // mdmCustomerSaleAreaVos.props = {
    //   ...mdmCustomerSaleAreaVos.props,
    //   saleAreaData: this.mdmCustomerSaleAreaVos,
    // };
    // title2.on = {
    //   add: () => {
    //     this.mdmCustomerSaleAreaVos.push({
    //       ...this.mdmCustomerSaleAreaVosItem,
    //       id: new Date().getTime(),
    //     });
    //     mdmCustomerSaleAreaVos.props = {
    //       ...mdmCustomerSaleAreaVos.props,
    //       saleAreaData: this.mdmCustomerSaleAreaVos,
    //     };
    //   },
    // };
    // 联系人
    // const mdmCustomerContactVos = this.getRule('mdmCustomerContactVos');
    // mdmCustomerContactVos.on = {
    //   del: (index) => {
    //     console.log(index);
    //     this.mdmCustomerContactVos.splice(index, 1);
    //   },
    // };
    // // 联系人信息添加按钮
    // const title3 = this.getRule('title3');
    // if (this.formConfig.code !== 'view') {
    //   title3.props.showAdd = true;
    // }
    // mdmCustomerContactVos.props = {
    //   ...mdmCustomerContactVos.props,
    //   contactInfoData: this.mdmCustomerContactVos,
    // };
    // title3.on = {
    //   add: () => {
    //     this.mdmCustomerContactVos.push({
    //       ...this.mdmCustomerContactVosItem,
    //       id: new Date().getTime(),
    //     });
    //     mdmCustomerContactVos.props = {
    //       ...mdmCustomerContactVos.props,
    //       contactInfoData: this.mdmCustomerContactVos,
    //     };
    //   },
    // };

    // 负责人信息
    const mdmCustomerDockingVos = this.getRule('mdmCustomerDockingVos');
    mdmCustomerDockingVos.on = {
      del: (index) => {
        this.mdmCustomerDockingVos.splice(index, 1);
      },
    };

    // 负责人添加按钮
    const title90 = this.getRule('title90');
    if (this.formConfig.code !== 'view') {
      title90.props.showAdd = true;
    }
    mdmCustomerDockingVos.props = {
      ...mdmCustomerDockingVos.props,
      extendInfoData: this.mdmCustomerDockingVos,
    };
    title90.on = {
      add: () => {
        this.mdmCustomerDockingVos.push({
          ...this.mdmCustomerDockingVosItem,
          id: new Date().getTime(),
        });
        mdmCustomerDockingVos.props = {
          ...mdmCustomerDockingVos.props,
          extendInfoData: this.mdmCustomerDockingVos,
        };
      },
    };

    // 开票信息
    // const mdmCustomerBillVos = this.getRule('mdmCustomerBillVos');
    // mdmCustomerBillVos.on = {
    //   del: (index) => {
    //     this.mdmCustomerBillVos.splice(index, 1);
    //   },
    // };

    // const title5 = this.getRule('title5');
    // if (this.formConfig.code !== 'view') {
    //   title5.props.showAdd = true;
    // }
    // mdmCustomerBillVos.props = {
    //   ...mdmCustomerBillVos.props,
    //   invoiceInfoData: this.mdmCustomerBillVos,
    // };
    // title5.on = {
    //   add: () => {
    //     this.mdmCustomerBillVos.push({
    //       ...this.mdmCustomerBillVosItem,
    //       id: new Date().getTime(),
    //     });
    //     mdmCustomerBillVos.props = {
    //       ...mdmCustomerBillVos.props,
    //       invoiceInfoData: this.mdmCustomerBillVos,
    //     };
    //   },
    // };
    // 所属组织名称
    // const orgName = this.getRule('orgCode');
    // orgName.props = {
    //   ...orgName.props,
    //   restful: '/mdm/baseTreeController/orgTree',
    //   restfulParams: {
    //     enableStatus: '009',
    //   },
    //   headers: { functionCode: 'select-org' },
    //   props: {
    //     value: 'code', // 唯一标识
    //     key: 'code',
    //     label: 'name', // 标签显示
    //     children: 'children', // 子级
    //   },
    // };
    // 客户组织
    // const customerOrgName = this.getRule('customerOrgCode');
    // customerOrgName.restful = '/mdm/baseTreeController/customerOrgTree';
    // customerOrgName.headers = { functionCode: 'select-customer-org' };
    // customerOrgName.restfulParams = {
    //   enableStatus: '009',
    // };
    // customerOrgName.props = {
    //   ...customerOrgName.props,
    //   props: {
    //     parent: 'parentCode', // 父级唯一标识
    //     value: 'code', // 唯一标识
    //     label: 'name', // 标签显示
    //     children: 'children', // 子级
    //   },
    // };

    // const customerCode = this.getRule('customerCode');
    // customerCode.validate = [
    //   ...customerCode.validate,
    //   {
    //     trigger: 'blur',
    //     pattern: '^[a-zA-Z0-9]*$',
    //     message: '仅能输入英文和数字的组合',
    //   },
    // ];
    // const customerContact = this.getRule('customerContact');
    // customerContact.validate = [
    //   {
    //     trigger: 'blur',
    //     pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
    //     message: '请输入正确的电话号码',
    //   },
    // ];
    // const telephone = this.getRule('telephone');

    // telephone.validate = [
    //   {
    //     trigger: 'blur',
    //     pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
    //     message: '请输入正确的电话号码',
    //   },
    // ];

    const len = Object.keys(this.formConfig).length;
    this.reload(this.rule);
    if (this.formConfig.code === 'add') {
      this.disabled(true, ['cityCode', 'districtCode']);
    }
    if (len === 0 || (len > 0 && this.formConfig.functionLevel === '0')) {
      this.hiddenFields(true, ['parentCode']);
    }
    if (this.formConfig.row && this.formConfig.row.id) {
      // console.log(this.formConfig);
      if (this.formConfig.code === 'edit') {
        const params = {
          positionCode: JSON.parse(localStorage.getItem('userInfo')).positionCode,
        };
        request.post(`/mdm/mdmRoleController/getRoleByPositionCode?positionCode=${params.positionCode}`).then((res) => {
          if (res.success) {
            const admin = (res.result || []).includes('ADMIN');
            const title9011 = this.getRule('title90');
            if (!admin) {
              title9011.props.showAdd = false;
              this.disabled(true, ['mdmCustomerDockingVos']);
            } else {
              title9011.props.showAdd = true;
              this.disabled(false, ['mdmCustomerDockingVos']);
            }
          }
        });
      }
      const data = {
        id: this.formConfig.row.id,
        customerCode: this.formConfig.customerCode,
      };
      request.get('/mdm/mdmCustomerMsgExtController/queryDetail', data).then((e) => {
        const { result } = e;
        if (!result) return;
        cityName.restfulParams = {
          parentCode: result && result.provinceCode,
        };
        if (result && result.provinceCode) {
          cityName.restful = '/mdm/mdmRegionController/selectStartWithProvince';
          cityName.props = {
            ...cityName.props,
            filterable: true,
            remote: true,
            remoteParams: 'regionName',
          };
          cityName.refresh = true;
        }
        districtName.restfulParams = {
          parentCode: result && result.cityCode,
        };
        if (result && result.cityCode) {
          districtName.restful = '/mdm/mdmRegionController/selectStartWithProvince';
          districtName.props = {
            ...districtName.props,
            filterable: true,
            remote: true,
            remoteParams: 'regionName',
          };
          districtName.refresh = true;
        }

        // result.form_list = [];
        // result.form_list.push({
        //   title: '销售区域',
        //   type: 'saleArea',
        //   list: [],
        // });
        // this.mdmCustomerSaleAreaVos = !result.mdmCustomerSaleAreaVos || result.mdmCustomerSaleAreaVos.length === 0
        //   ? [
        //     {
        //       areaOne: '',
        //       areaTwo: '',
        //       areaThree: '',
        //       id: new Date().getTime(),
        //     },
        //   ]
        //   : result.mdmCustomerSaleAreaVos;
        // this.mdmCustomerContactVos = !result.mdmCustomerContactVos || result.mdmCustomerContactVos.length === 0
        //   ? [
        //     {
        //       contactMain: '',
        //       contactName: '',
        //       contactPhone: '',
        //       id: new Date().getTime(),
        //     },
        //   ]
        //   : result.mdmCustomerContactVos;
        this.mdmCustomerDockingVos = !result.mdmCustomerDockingVos || result.mdmCustomerDockingVos.length === 0
          ? [
            {
              orgCode: '',
              positionCode: '',
              // channel: '',
              // saleCompany: '',
              ext1: '',
              ext2: '',
              contactPhone: '',
              fullName: '',
              id: new Date().getTime(),
            },
          ]
          : result.mdmCustomerDockingVos;

        // this.mdmCustomerBillVos = !result.mdmCustomerBillVos || result.mdmCustomerBillVos.length === 0
        //   ? [
        //     {
        //       billCompany: '', // 开票单位
        //       taxNumber: '', // 税号
        //       legal: '', // 法人
        //       depositBank: '', // 开户银行
        //       bankAccount: '', // 银行账号
        //       billMain: '', // 是否是默认开票信息，1是0否
        //       id: new Date().getTime(),
        //     },
        //   ]
        //   : result.mdmCustomerBillVos;
        // mdmCustomerSaleAreaVos.props = {
        //   ...mdmCustomerSaleAreaVos.props,
        //   saleAreaData: this.mdmCustomerSaleAreaVos,
        // };
        // mdmCustomerContactVos.props = {
        //   ...mdmCustomerContactVos.props,
        //   contactInfoData: this.mdmCustomerContactVos,
        // };
        mdmCustomerDockingVos.props = {
          ...mdmCustomerDockingVos.props,
          extendInfoData: this.mdmCustomerDockingVos,
        };
        // mdmCustomerBillVos.props = {
        //   ...mdmCustomerBillVos.props,
        //   invoiceInfoData: this.mdmCustomerBillVos,
        // };
        // result.certificateImageList = result.certificateImageList || [];
        result.corporateIdentityImageList = result.corporateIdentityImageList || [];
        this.setValue(result);

        // 财务信息
        const {
          financeContact, billPhone, billType, bank, bankAccount, accountName, bankAddress, rate, takerPhone, takerMailCode, ticketAddress,
        } = result.customerFinanceVo || {};
        // 联系人
        const { contactName, contactPhone, ext1 } = result.mdmCustomerContactVos[0] || {};
        const {
          beEntrust,
          beEntrustPhone,
          entrust,
          entrustPhone,
        } = result.customerDeliveryVo || {};
        // 发货信息
        this.setValue({
          beEntrust,
          beEntrustPhone,
          entrust,
          entrustPhone,
          financeContact,
          billPhone,
          billType,
          bank,
          bankAccount,
          accountName,
          bankAddress,
          rate,
          takerPhone,
          takerMailCode,
          ticketAddress,
          contactName,
          contactPhone,
          ext1, // 电子邮件
          contactMain: 1, // 是否主要联系人
        });

        // const registeredAddress = this.getRule('registeredAddress');
        // registeredAddress.props = {
        //   ...registeredAddress.props,
        //   lat: result.latitude,
        //   lng: result.longitude,
        // };
        if (!result.provinceCode) {
          this.disabled(true, ['cityCode', 'districtCode']);
        }
        if (!result.cityCode) {
          this.disabled(true, ['districtCode']);
        }
        if (result.actApproveStatus === '3') {
          this.disabled(true, ['customerName', 'customerTax']);
        }
      });
    }
  },
  methods: {

    /**
     * 表单渲染完成后回调
     */
    formComplete() {

    },
    async getDic() {
      const resData = await request.post('/mdm/mdmdictdata/list', {
        dictTypeCode: 'customer_add_section',
      });
      return resData.result;
    },
    // 提交
    submit() {
      const formData = this.getFormData();
      // this.showData.forEach((item) => {
      // if (item.dictCode === 'sales_area' && item.dictValue === 'Y') {
      //   const mdmCustomerSaleAreaVos = this.mdmCustomerSaleAreaVos.length > 0
      //     ? this.fApi.method('mdmCustomerSaleAreaVos', 'getFormData')()
      //     : [];
      //   formData.mdmCustomerSaleAreaVos = mdmCustomerSaleAreaVos;
      // }
      // if (item.dictCode === 'contact_information' && item.dictValue === 'Y') {
      //   const mdmCustomerContactVos = this.mdmCustomerContactVos.length > 0
      //     ? this.fApi.method('mdmCustomerContactVos', 'getFormData')()
      //     : [];
      //   formData.mdmCustomerContactVos = mdmCustomerContactVos;
      // }
      //   if (item.dictCode === 'extended_information' && item.dictValue === 'Y') {
      //     const mdmCustomerDockingVos = this.mdmCustomerDockingVos.length > 0
      //       ? this.fApi.method('mdmCustomerDockingVos', 'getFormData')()
      //       : [];

      //     formData.mdmCustomerDockingVos = mdmCustomerDockingVos;
      //   }
      //   if (item.dictCode === 'customer_bill' && item.dictValue === 'Y') {
      //     const mdmCustomerBillVos = this.mdmCustomerBillVos.length > 0
      //       ? this.fApi.method('mdmCustomerBillVos', 'getFormData')()
      //       : [];

      //     formData.mdmCustomerBillVos = mdmCustomerBillVos;
      //   }
      // });
      const mdmCustomerDockingVos = this.mdmCustomerDockingVos.length > 0
        ? this.fApi.method('mdmCustomerDockingVos', 'getFormData')()
        : [];
      if (this.fApi.method('mdmCustomerDockingVos', 'getFormData')() === 'noCheck') {
        return;
      }
      formData.mdmCustomerDockingVos = mdmCustomerDockingVos;
      console.log('/mdm/mdmCustomerMsgExtController/queryDetail', mdmCustomerDockingVos);
      // 发货信息
      formData.customerDeliveryVo = {
        beEntrust: formData.beEntrust,
        beEntrustPhone: formData.beEntrustPhone,
        entrust: formData.entrust,
        entrustPhone: formData.entrustPhone,
      };

      // 财务信息
      const {
        financeContact, billPhone, billType, bank, bankAccount, accountName, bankAddress, rate, takerPhone, takerMailCode, ticketAddress,
      } = formData;

      formData.customerFinanceVo = {
        financeContact, billPhone, billType, bank, bankAccount, accountName, bankAddress, rate, takerPhone, takerMailCode, ticketAddress,
      };

      // 联系人
      formData.mdmCustomerContactVos = [
        {
          contactName: formData.contactName,
          contactPhone: formData.contactPhone,
          ext1: formData.ext1, // 电子邮件
          contactMain: 1, // 是否主要联系人
        },
      ];

      if (formData) {
        const url = '/mdm/mdmCustomerMsgExtController/saveOrUpdate';
        let params = formData;

        if (this.formConfig && this.formConfig.code === 'add') {
          formData.approvalBusinessCode = 'mdm_customer_default_curd';
        }
        if (this.formConfig && this.formConfig.code === 'edit') {
          params = Object.assign(this.formConfig, formData);
        }
        delete params.form_list;
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
            // this.$emit('resetTree');
          }
        });
      }
    },
  },
};
</script>
